import { render } from "./DesignList.vue?vue&type=template&id=299856be"
import script from "./DesignList.vue?vue&type=script&lang=js"
export * from "./DesignList.vue?vue&type=script&lang=js"

import "./DesignList.vue?vue&type=style&index=0&id=299856be&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__